// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Forms/Subscription/Subscription.css */

.subscription-container {
    padding: 1rem;
    margin: auto;
    font-family: Verdana, Arial, Helvetica, sans-serif;
    width: 100%;

}

.subscription-card {
    background: #1e1e1e;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 0.8rem;
    margin: 1rem auto;
}

.subscription-card.all-time {
    margin-top: 10px;
    background: rgba(255, 255, 255, 0.05);
}

.subscription-card.all-time .subscription-header {
    border-bottom-color: rgba(255, 255, 255, 0.1);
}

.subscription-card.all-time .package-name {
    color: #EF6F53;
}

.subscription-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #eee;
}

.package-name {
    color: #EF6F53;
    font-size: 1.12rem;
    font-weight: 800;
    margin-bottom: 0.25rem;
}

.expiry-date {
    color: #EF6F53;
    font-size: 0.9rem;
}

.message-stats {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.5rem;
    margin-bottom: 0.15rem;
    
}

.stat-item {
    text-align: center;
    padding: 0.5rem;
    background: #253e5897;
    color: white;
    border-radius: 8px;
}

.stat-item label {
    display: block;
    font-size: 0.9rem;
    color: #EF6F53;
}

.stat-item span {
    font-size: 1.25rem;
    font-weight: bold;

}

.progress-section {
    margin-bottom: 1rem;
}

.progress-section label {
    display: block;
    color: #EF6F53;
    font-weight: bold;
    margin-bottom: 0.5rem;
}

.progress-bar-container {
    height: 10px;
    background: #eee;
    border-radius: 5px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    transition: width 0.3s ease;
}

.subscription-footer {
    color: #EF6F53;
    font-size: 0.9rem;
    text-align: right;
}

.subscription-loading,
.subscription-error,
.subscription-not-found {
    text-align: center;
    padding: 2rem;
    color: #EF6F53;
}

.subscription-error {
    color: #EF6F53;
    font-weight: bold;
}

/* Add this CSS at the end of the file or in your Subscription.css */
.tooltip-container {
    position: relative;
    display: inline-block;
}

.tooltip-text {
    visibility: hidden;
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 5px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    left: -150px;
    transform: translateX(-50%);
    white-space: nowrap;
    opacity: 0;
    transition: opacity 0.3s;
}

.tooltip-container:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
    font-size: 0.75rem;
    color: #EF6F53;
}

@keyframes blink {
    0% { color: white; }
    50% { color: red; }
    100% { color: white; }
}

.low-remaining {
    animation: blink 1.5s infinite;
}
/* ********** */

.message-statss {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.5rem;
    margin: 0;
}

.subscription-headerr {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.stat-itemm {
    text-align: center;
    padding: 0.5rem;
    background: #253e5897;
    color: white;
    border-radius: 8px;
}

.stat-itemm label {
    display: block;
    font-size: 0.9rem;
    color: #EF6F53;
    font-weight: 500;
}

.stat-itemm span {
    font-size: 1.25rem;
    font-weight: bold;
}

/* ******** */

.package-stats {
    margin-top: 1rem;
    padding: 0.15rem;
    border-top: 1px solid #ccc;
}

.package-stats-heading{
    color: #EF6F53;
    font-size: 1.12rem;
    font-weight: 800;
    text-align: left;
    margin-top: 0.5rem;
}

.package-stat-list {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
}

.package-stat-item {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.333% - 1rem);
    display: flex;
    justify-content: space-between;
    background-color: #f9f9f9;
    padding: 0.15rem;
    border-radius: 5px;
    border: 1px solid #ddd;
}

.package-namee {
    font-weight: 500;
    font-size: 0.9rem;
    color: #EF6F53;
}

.package-count {
    color: #364c63;
    font-size: 0.9rem;
    font-weight: 600;
}


@media (max-width: 600px) {
    .subscription-container {
        padding: 1rem;
    }

    .message-stats {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .subscription-header {
        flex-direction: column;
        text-align: center;
        gap: 1rem;
    }
}


.headerr-containerr{
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 1rem;

}

.reports-titlee{
    color: #EF6F53;
    text-align: center;
    font-size: 1.25rem;
    flex-shrink: 0;
    font-weight: 700;
    width: 100%;
    margin-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/routes/Forms/Subscription/Subscription.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D;IACI,aAAa;IACb,YAAY;IACZ,kDAAkD;IAClD,WAAW;;AAEf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;IACzC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;AACzC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,sBAAsB;;AAE1B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;;AAErB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;;;IAGI,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,oEAAoE;AACpE;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,KAAK,YAAY,EAAE;IACnB,MAAM,UAAU,EAAE;IAClB,OAAO,YAAY,EAAE;AACzB;;AAEA;IACI,8BAA8B;AAClC;AACA,eAAe;;AAEf;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,aAAa;;AAEb;IACI,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,YAA8B;IAA9B,cAA8B;IAA9B,gCAA8B;IAC9B,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;QAClB,SAAS;IACb;AACJ;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB","sourcesContent":["/* src/components/routes/Forms/Subscription/Subscription.css */\n\n.subscription-container {\n    padding: 1rem;\n    margin: auto;\n    font-family: Verdana, Arial, Helvetica, sans-serif;\n    width: 100%;\n\n}\n\n.subscription-card {\n    background: #1e1e1e;\n    border-radius: 10px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    padding: 0.8rem;\n    margin: 1rem auto;\n}\n\n.subscription-card.all-time {\n    margin-top: 10px;\n    background: rgba(255, 255, 255, 0.05);\n}\n\n.subscription-card.all-time .subscription-header {\n    border-bottom-color: rgba(255, 255, 255, 0.1);\n}\n\n.subscription-card.all-time .package-name {\n    color: #EF6F53;\n}\n\n.subscription-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n    padding-bottom: 0.5rem;\n    border-bottom: 1px solid #eee;\n}\n\n.package-name {\n    color: #EF6F53;\n    font-size: 1.12rem;\n    font-weight: 800;\n    margin-bottom: 0.25rem;\n}\n\n.expiry-date {\n    color: #EF6F53;\n    font-size: 0.9rem;\n}\n\n.message-stats {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 0.5rem;\n    margin-bottom: 0.15rem;\n    \n}\n\n.stat-item {\n    text-align: center;\n    padding: 0.5rem;\n    background: #253e5897;\n    color: white;\n    border-radius: 8px;\n}\n\n.stat-item label {\n    display: block;\n    font-size: 0.9rem;\n    color: #EF6F53;\n}\n\n.stat-item span {\n    font-size: 1.25rem;\n    font-weight: bold;\n\n}\n\n.progress-section {\n    margin-bottom: 1rem;\n}\n\n.progress-section label {\n    display: block;\n    color: #EF6F53;\n    font-weight: bold;\n    margin-bottom: 0.5rem;\n}\n\n.progress-bar-container {\n    height: 10px;\n    background: #eee;\n    border-radius: 5px;\n    overflow: hidden;\n}\n\n.progress-bar {\n    height: 100%;\n    transition: width 0.3s ease;\n}\n\n.subscription-footer {\n    color: #EF6F53;\n    font-size: 0.9rem;\n    text-align: right;\n}\n\n.subscription-loading,\n.subscription-error,\n.subscription-not-found {\n    text-align: center;\n    padding: 2rem;\n    color: #EF6F53;\n}\n\n.subscription-error {\n    color: #EF6F53;\n    font-weight: bold;\n}\n\n/* Add this CSS at the end of the file or in your Subscription.css */\n.tooltip-container {\n    position: relative;\n    display: inline-block;\n}\n\n.tooltip-text {\n    visibility: hidden;\n    background-color: black;\n    color: #fff;\n    text-align: center;\n    padding: 5px;\n    position: absolute;\n    z-index: 1;\n    bottom: 125%;\n    left: -150px;\n    transform: translateX(-50%);\n    white-space: nowrap;\n    opacity: 0;\n    transition: opacity 0.3s;\n}\n\n.tooltip-container:hover .tooltip-text {\n    visibility: visible;\n    opacity: 1;\n    font-size: 0.75rem;\n    color: #EF6F53;\n}\n\n@keyframes blink {\n    0% { color: white; }\n    50% { color: red; }\n    100% { color: white; }\n}\n\n.low-remaining {\n    animation: blink 1.5s infinite;\n}\n/* ********** */\n\n.message-statss {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 0.5rem;\n    margin: 0;\n}\n\n.subscription-headerr {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.stat-itemm {\n    text-align: center;\n    padding: 0.5rem;\n    background: #253e5897;\n    color: white;\n    border-radius: 8px;\n}\n\n.stat-itemm label {\n    display: block;\n    font-size: 0.9rem;\n    color: #EF6F53;\n    font-weight: 500;\n}\n\n.stat-itemm span {\n    font-size: 1.25rem;\n    font-weight: bold;\n}\n\n/* ******** */\n\n.package-stats {\n    margin-top: 1rem;\n    padding: 0.15rem;\n    border-top: 1px solid #ccc;\n}\n\n.package-stats-heading{\n    color: #EF6F53;\n    font-size: 1.12rem;\n    font-weight: 800;\n    text-align: left;\n    margin-top: 0.5rem;\n}\n\n.package-stat-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n}\n\n.package-stat-item {\n    flex: 1 1 calc(33.333% - 1rem);\n    display: flex;\n    justify-content: space-between;\n    background-color: #f9f9f9;\n    padding: 0.15rem;\n    border-radius: 5px;\n    border: 1px solid #ddd;\n}\n\n.package-namee {\n    font-weight: 500;\n    font-size: 0.9rem;\n    color: #EF6F53;\n}\n\n.package-count {\n    color: #364c63;\n    font-size: 0.9rem;\n    font-weight: 600;\n}\n\n\n@media (max-width: 600px) {\n    .subscription-container {\n        padding: 1rem;\n    }\n\n    .message-stats {\n        grid-template-columns: 1fr;\n        gap: 1rem;\n    }\n\n    .subscription-header {\n        flex-direction: column;\n        text-align: center;\n        gap: 1rem;\n    }\n}\n\n\n.headerr-containerr{\n    display: flex;\n    align-items: center;\n    position: relative;\n    margin-bottom: 1rem;\n\n}\n\n.reports-titlee{\n    color: #EF6F53;\n    text-align: center;\n    font-size: 1.25rem;\n    flex-shrink: 0;\n    font-weight: 700;\n    width: 100%;\n    margin-top: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
